import { Injectable } from '@angular/core';
import { BehaviorSubject, from } from 'rxjs';

import { InsertLinkEvent } from '../model/event.model';
import { WkAlfrescoApiService } from './wk-alfresco-api.service';

export interface InsertDocumentEventInterface {
  opened: boolean;
  event?: InsertLinkEvent;
  edit?: boolean;
  dataLink?: any;
}
@Injectable({
  providedIn: 'root',
})
export class WkInsertDocumentLinkService {
  browseBtnOpened = new BehaviorSubject<InsertDocumentEventInterface>({
    opened: false,
  });
  currentEventLinkDocument = new BehaviorSubject<any>(null);
  _linkDetails = new BehaviorSubject<any>('');
  _documentLinkDetails = new BehaviorSubject<any>('');

  constructor(private readonly apiService: WkAlfrescoApiService) {}

  getLinkDetails() {
    return this._linkDetails.asObservable();
  }

  setLinkDetails(data: any) {
    this._linkDetails.next(data);
  }

  setDocumentLinkDetails(data: any) {
    this._documentLinkDetails.next(data);
  }

  getNodeOfLinkedDoc(linkAddress: string) {
    const request = {
      query: {
        query: `=apollo:tenantId:"${linkAddress}"`,
        language: 'afts',
      },
      include: ['properties'],
    };
    return from(this.apiService.searchApi.search(request));
  }
}
